module.exports = __webpack_public_path__ + "static/media/L.6c7b433f.jpg";